export const isDigital = ({ tags }: { tags: { name: string }[] }) => tags.some(({ name }) => name.match(/^digital$/i));
